import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@material-ui/core"
import { ArrowDropDown } from "@material-ui/icons"
import React, { useState } from "react"

interface IRBIAccordion{
    title:React.ReactNode,
    expanded?: boolean,
    id?:string
}

 const RBIAccordion: React.FC<IRBIAccordion> = (props) => {
    const [expanded, setExpanded] = useState(props.expanded);

    const expand = () => {
        setExpanded((expanded) => !expanded);
    }

    return <Accordion 
        expanded= {expanded} 
        onChange={expand}
        role={props.id}
        style={{
            border:"1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "4px",
            marginBottom: "10px"
        }}
        id={props.id}
        >
        <AccordionSummary 
            expandIcon={<ArrowDropDown />}
            style={{
                borderBottom:"1px solid rgba(0, 0, 0, 0.12)",
            }}
        >
            {props.title}
        </AccordionSummary>
        <AccordionDetails style={{
            display:"flex",
            flexDirection:"column"
        }}>
            {props.children}
        </AccordionDetails>
    </Accordion>
}

export default RBIAccordion